import { render } from "./FooterMenue.vue?vue&type=template&id=5ac65b84"
import script from "./FooterMenue.vue?vue&type=script&lang=js"
export * from "./FooterMenue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__